module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("‘And I John saw these things, and heard them.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Revelation 22:8")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024016e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 66
// module chunks = 0